import { Api } from '../services/api.ts';
import type { FuenteEnlace } from '../types/index.ts';

let enlacesCache: FuenteEnlace[] = [];

export function initEnlaces() {
  const tableBody = document.querySelector('#table-links tbody') as HTMLTableSectionElement | null;
  const formAdd = document.getElementById('form-add-link') as HTMLFormElement | null;

  async function loadEnlaces() {
    try {
      enlacesCache = await Api.getEnlaces();
      render();
    } catch (err) {
      console.error('Error al cargar enlaces:', err);
    }
  }

  function render() {
    if (!tableBody) return;
    tableBody.innerHTML = '';

    enlacesCache.forEach((l) => {
      const tr = document.createElement('tr');
      tr.innerHTML = `
        <td><strong>${escapeHtml(l.titulo)}</strong></td>
        <td><span style="font-weight:600; font-size:0.78rem;">${escapeHtml(l.caso_estudio)}</span></td>
        <td style="font-size:0.8rem; color:#475569;">${escapeHtml(l.descripcion)}</td>
        <td style="text-align:center;">
          <a href="${escapeHtml(l.url)}" target="_blank" rel="noopener noreferrer" class="btn-secondary" style="text-decoration:none; padding:4px 8px; font-size:0.75rem; display:inline-flex; align-items:center; gap:4px;">
            <span>Abrir</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
          </a>
        </td>
        <td style="text-align:center;">
          <button data-del-id="${l.id}" class="btn-del" title="Eliminar enlace cartográfico">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
          </button>
        </td>
      `;
      tableBody.appendChild(tr);
    });

    tableBody.querySelectorAll('button[data-del-id]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const id = btn.getAttribute('data-del-id');
        if (!id) return;
        if (confirm('¿Eliminar esta fuente cartográfica?')) {
          try {
            await Api.deleteEnlace(id);
            enlacesCache = enlacesCache.filter(l => l.id !== id);
            render();
          } catch (err) {
            alert('Error al eliminar enlace de SQLite');
          }
        }
      });
    });
  }

  formAdd?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const titleInput = document.getElementById('link-title') as HTMLInputElement | null;
    const urlInput = document.getElementById('link-url') as HTMLInputElement | null;
    const caseInput = document.getElementById('link-case') as HTMLSelectElement | null;
    const descInput = document.getElementById('link-desc') as HTMLInputElement | null;

    if (!titleInput?.value.trim() || !urlInput?.value.trim()) return;

    try {
      const res = await Api.addEnlace({
        titulo: titleInput.value.trim(),
        url: urlInput.value.trim(),
        caso_estudio: caseInput?.value || 'El Raval',
        descripcion: descInput?.value.trim() || ''
      });

      enlacesCache.push({
        id: res.id,
        titulo: titleInput.value.trim(),
        url: urlInput.value.trim(),
        caso_estudio: caseInput?.value || 'El Raval',
        descripcion: descInput?.value.trim() || ''
      });

      titleInput.value = '';
      urlInput.value = '';
      if (descInput) descInput.value = '';
      render();
    } catch (err) {
      alert('Error al guardar enlace en SQLite');
    }
  });

  loadEnlaces();
}

function escapeHtml(str: string): string {
  const div = document.createElement('div');
  div.innerText = str;
  return div.innerHTML;
}
